import { PAGOS_LOGOS } from '@/lib/brand';
import { cn } from '@/lib/utils';

const TARJETAS = [
  { src: PAGOS_LOGOS.visa, alt: 'Visa' },
  { src: PAGOS_LOGOS.mastercard, alt: 'Mastercard' },
  { src: PAGOS_LOGOS.amex, alt: 'American Express' },
  { src: PAGOS_LOGOS.carnet, alt: 'Carnet' },
] as const;

function LogoChip({ src, alt, compact }: { src: string; alt: string; compact?: boolean }) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-surface-200',
        compact ? 'h-8 w-12' : 'h-10 w-[3.65rem]',
      )}
    >
      <img src={src} alt={alt} className={cn('w-auto object-contain', compact ? 'h-5 max-w-[2.6rem]' : 'h-7 max-w-[3.2rem]')} />
    </span>
  );
}

export function PaymentMarks({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <div
      className={cn('flex flex-wrap items-center gap-2', className)}
      aria-label="Tarjetas aceptadas: Visa, Mastercard, American Express y Carnet. Pagos con Openpay"
    >
      {TARJETAS.map((marca) => (
        <LogoChip key={marca.alt} src={marca.src} alt={marca.alt} compact={compact} />
      ))}
      <span className={cn('mx-0.5 w-px self-stretch bg-surface-200', compact ? 'min-h-6' : 'min-h-8')} aria-hidden />
      <a
        href="https://www.openpay.mx"
        target="_blank"
        rel="noreferrer"
        title="Openpay"
        className={cn(
          'inline-flex items-center justify-center rounded-md bg-white ring-1 ring-surface-200',
          compact ? 'h-8 w-8' : 'h-10 w-10',
        )}
      >
        <img
          src={PAGOS_LOGOS.openpay}
          alt="Openpay"
          className={cn('object-contain', compact ? 'h-5 w-5' : 'h-7 w-7')}
        />
      </a>
    </div>
  );
}
